import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../service/common.service';
import { Router } from '@angular/router';
import { Gruppo } from '../../models/gruppo';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from '../../../environments/environment';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-addgruppo',
  templateUrl: './addgruppo.component.html',
  styleUrls: ['./addgruppo.component.css']
})
export class AddgruppoComponent implements OnInit {
  gruppo: Gruppo=new Gruppo();
  hide = true;
  rc:number;
  gruppotoedit: boolean;
  IPAddress:string;
  Port:string;
  Protocol:string;
  registerForm: FormGroup;
  submitted = false;

  public message =  sessionStorage.getItem('token');

  constructor(private httpClient: HttpClient, private commonService: CommonService,
    private router: Router, private formBuilder: FormBuilder) {
      if (environment.address.isLocal){
        this.IPAddress=environment.address.localIP;
        this.Port=environment.address.localPort;
        this.Protocol=environment.address.localProtocol;
      }else{
        this.IPAddress=environment.address.remoteIP;
        this.Port=environment.address.remotePort;
        this.Protocol=environment.address.remoteProtocol;
      }

    }

  ngOnInit(): void {
    if (this.registerForm===undefined){
    this.registerForm = this.formBuilder.group({
            Nome: ['', Validators.required],
            Descrizione: [''],
            Codice: ['0'],
            Codiceistanza: ['0']
        });
    }


        if (this.commonService.selectedGruppo!=undefined){
          this.gruppo=this.commonService.selectedGruppo;
          this.commonService.selectedGruppo=undefined;

          this.registerForm.setValue({
            Nome: this.gruppo.Nome,
            Descrizione: this.gruppo.Descrizione,
            Codice: this.gruppo.Codice,
            Codiceistanza: this.commonService.currentIstanza.Codice
          });
        }else{
          this.gruppo.Nome='',
          this.gruppo.Descrizione='',
          this.gruppo.Codice=0,
          this.gruppo.Codiceistanza=0;
        }
    }

get f() { return this.registerForm.controls; }

save() {

        this.submitted = true;

        // stop here if form is invalid
        if (this.registerForm.invalid) {
            alert("Errore: verifica i campi indicati con *");
            return;
        }else{
            this.commonService.saveGruppo(this.registerForm.value).subscribe(data => {
              this.rc=Number(data); //ritorna l'id dell'utente se è stato creato con successo
              //console.log("--->SaveUser"+this.rc.toString());
              if (this.rc===0){
                alert("Gruppo già esistente");
              }else if (this.rc===-1){
                alert("Errore creazione gruppo");
              }else{
                alert("Gruppo salvato con successo");
                this.router.navigate(['gruppi']);
              }
            });

        }
    //    alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.registerForm.value))
    }

  cancel(){
    this.commonService.selectedGruppo=null;
    this.router.navigate(['gruppi']);
  }

}
